import { render, staticRenderFns } from "./MajorMaintenanceList.vue?vue&type=template&id=050a6250"
import script from "./MajorMaintenanceList.vue?vue&type=script&lang=js"
export * from "./MajorMaintenanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports